<app-modal [title]="'Nueva zona'">
  <app-form [formGroup]="saveForm">
    <div class="mb-5 grid grid-cols-1 gap-3 md:grid-cols-2">
      <div>
        <app-label for="zona_nombre">Nombre de la zona</app-label>
        <app-input-field
          id="zona_nombre"
          type="text"
          formControlName="nombre"
          placeholder="Ingrese el nombre de la zona"
        />
      </div>

      <div>
        <app-label for="zona_pais_id">País</app-label>
        <app-select
          id="zona_pais_id"
          formControlName="ubi_pais_id"
          placeholder="Seleccione un país"
          [options]="paises | toSelectOptions"
        />
      </div>

      <div>
        <app-label for="zona_departamento_id">Departamento</app-label>
        <app-select
          id="zona_departamento_id"
          formControlName="ubi_departamento_id"
          placeholder="Seleccione un departamento"
          [options]="departamentos | toSelectOptions"
          [disabled]="!saveForm.get('ubi_pais_id')?.value"
        />
      </div>

      <div>
        <app-label for="zona_ciudad_id">Ciudad</app-label>
        <app-select
          id="zona_ciudad_id"
          formControlName="ubi_ciudad_id"
          placeholder="Seleccione una ciudad"
          [options]="ciudades | toSelectOptions"
          [disabled]="!saveForm.get('ubi_departamento_id')?.value"
        />
      </div>
    </div>
  </app-form>

  <app-creation-buttons *hasPermission="'zonas:create'"
    [valid]="saveForm.valid"
    [process]="loading"
    (onCreateClick)="saveZona()"
    (onCancelClick)="cancel()"
  />
</app-modal>
